import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Row, Col } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import "../../assets/css/evento.css";

import logo from "../../assets/images/2025/Logos_Botones_Iconos/casaduana_LogoHeader.svg";
import ima2 from "../../assets/images/2025/Logos_Botones_Iconos/casaduana_ApartaTuLugar.svg";

const secciones = [
  { nombre: "Acerca de", url: "/#acerca-de", nombre_en: "ABOUT US" },
  { nombre: "Beneficios", url: "/#beneficios", nombre_en: "ABOUT US" },
  { nombre: "Programa", url: "/#programa", nombre_en: "SCHEDULE" },
  { nombre: "Speakers", url: "/#speakers", nombre_en: "" },
  { nombre: "Organizadores", url: "/#organizadores" },
];

const Header = (props) => {
  const [mostrar_submenu, setMostrarSubmenu] = useState(false);

  let location = useLocation();

  const rutaActual = location.pathname + location.hash;

  const [seccionActiva, setSeccionActiva] = useState("");

useEffect(() => {
  const opciones = {
    root: null,
    rootMargin: "-110px 0px 0px 0px",  // evita que la sección de arriba quede activa
    threshold: 0.2,
  };

  const observer = new IntersectionObserver((entries) => {
    const visibles = entries
      .filter(entry => entry.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

    if (visibles.length > 0) {
      const id = visibles[0].target.id;
      setSeccionActiva("/#" + id);
    }
  }, opciones);

  const ids = ["acerca-de", "beneficios", "programa", "speakers", "organizadores"];
  ids.forEach(id => {
    const el = document.getElementById(id);
    if (el) observer.observe(el);
  });

  return () => observer.disconnect();
}, []);



  let visualizar_secciones = secciones.map((seccion) => {
    return (
      <Link className="titles" to={seccion.url} key={seccion.url}>
       <span
  className={
    seccionActiva === seccion.url
      ? "seccion_sel"
      : "seccion"
  }
>

          {seccion.nombre}
        </span>
      </Link>
    );
  });

  return (
    <>
      <Row
        className="back_menu_scroll"
        justify={"center"}
        style={{
          paddingTop: "10px",
          paddingBottom: "10px",
          position: "fixed",
          zIndex: "99",
          width: "100%",
        }}
      >
        <Col xs={24} md={22}>
          <Row justify="space-between" align="middle" className="header">
            {/* LOGO - IZQUIERDA */}
            <Col xs={8} md={6} style={{ textAlign: "left" }}>
              <img alt="logo" style={{ width: "60%" }} src={logo} />
            </Col>

            {/* SECCIONES - CENTRO */}
            <Col xs={0} md={12} style={{ textAlign: "center" }}>
              {visualizar_secciones}
            </Col>

            {/* BOTÓN REGISTRO - DERECHA */}
            <Col xs={0} md={6} style={{ textAlign: "right" }}>
              <Link to="/#registro">
                <img src={ima2} style={{ width: "130px" }} alt="resgistro" />
              </Link>
            </Col>

            {/* MENÚ HAMBURGUESA - SOLO EN MÓVIL */}
            <Col xs={4} md={0} style={{ textAlign: "right" }}>
              <MenuOutlined
                onClick={() => setMostrarSubmenu(!mostrar_submenu)}
                style={{ padding: "0px", fontSize: "20px", color: "#263259" }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Header;
